module.exports = __webpack_public_path__ + "img/philosophy-beyond-spacetime-cover.fb523433.jpg";